import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type MedicalVideoIconProps = SvgIconProps

export function MedicalVideoIcon(props: MedicalVideoIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Medical_Video">
        <g>
          <g id="XMLID_00000109013945759299345410000006009098779423621048_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M184.852,19.463v119.97c0,1.65-1.34,3-3,3h-60.62h-15.28h-12.12h-15.27h-60.39
					c-1.67,0-3.03-1.36-3.03-3.04V19.463c0-1.68,1.36-3.03,3.03-3.03h163.65C183.502,16.433,184.852,17.783,184.852,19.463z
					 M174.572,132.143V26.853H25.432v105.29h12.04h44.81h44.79H174.572z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M138.272,40.123c13.68,0,24.78,11.1,24.78,24.78s-11.1,24.78-24.78,24.78
					c-13.69,0-24.78-11.1-24.78-24.78S124.582,40.123,138.272,40.123z M133.932,76.223l14.71-12.18l-14.71-10.76V76.223z"
              />
              <polygon
                style={{ fill: htmlColor || '#A7A9AC' }}
                points="141.142,173.283 141.142,183.573 58.852,183.573 58.852,173.283 74.282,173.283 
					125.502,173.283 				"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M63.412,65.813c-0.67-0.72-1.58-1.83-2.37-3.32c-0.23-0.44-0.44-0.89-0.62-1.35
					c-2.13-5.38-0.92-11.8-0.65-12.83c5.09-19.28,39.55-20.57,44.97,0c0.28,1.04,1.5,7.59-0.71,13c-0.16,0.4-0.35,0.8-0.55,1.18
					c-0.8,1.51-1.72,2.63-2.4,3.35c0,0,0,0,0,0.02l-18.15-14.9l-0.67,6.32c-5.77-2.23-11.08-3.67-15.61-4.62
					c-0.64,1.38-1.3,3.02-1.82,4.92c-0.93,3.32-1.14,6.29-1.13,8.57c-0.08-0.11-0.18-0.19-0.27-0.29c0-0.02,0-0.02,0-0.02
					C63.422,65.833,63.412,65.823,63.412,65.813z"
              />
            </g>
            <g>
              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="125.502,173.283 
					141.142,173.283 141.142,183.573 58.852,183.573 58.852,173.283 74.282,173.283 				"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M105.952,143.253v12.12
					c0,3.34-2.72,6.07-6.06,6.07c-3.33,0-6.06-2.73-6.06-6.07v-12.12"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M78.562,143.253v15.61
					c0,5.2-1.58,10.07-4.28,14.12"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M121.232,143.253v15.61
					c0,5.2,1.57,10.07,4.27,14.12"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M78.562,142.433h-60.39
					c-1.67,0-3.03-1.36-3.03-3.04V19.463c0-1.68,1.36-3.03,3.03-3.03h163.65c1.68,0,3.03,1.35,3.03,3.03v119.97c0,1.65-1.34,3-3,3
					h-60.62h-15.28h-12.12H78.562z"
              />
              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="37.472,132.143 
					25.432,132.143 25.432,26.853 174.572,26.853 174.572,132.143 127.072,132.143 82.282,132.143 				"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M55.252,128.583h-5.93v-12.85c0-5.84,4.74-10.58,10.59-10.58h1.12c5.85,0,10.59,4.74,10.59,10.58v12.85h-6.77"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M58.312,103.573c0-1.15,0.17-2.26,0.5-3.31c1.41-4.57,5.66-7.89,10.7-7.89"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M95.752,92.373c5.16,0,9.51,3.49,10.81,8.24c0.26,0.94,0.4,1.94,0.4,2.96v9.29"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M115.472,121.363c0,4.25-3.45,7.7-7.7,7.7c-4.26,0-7.71-3.45-7.71-7.7c0-4.26,3.45-7.71,7.71-7.71
					C112.022,113.653,115.472,117.103,115.472,121.363z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M63.382,65.773c0.01,0.02,0.02,0.03,0.03,0.04"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M62.092,71.883c-0.61-1.65-2.7-0.64-4.31-4.48c-2.35-5.63,0.36-6.98,2.2-6.08"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M101.952,71.883c0.6-1.65,2.7-0.64,4.31-4.48c2.35-5.63-0.36-6.98-2.21-6.08"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M62.092,71.883c1.15,7.65,4.69,14.16,9.53,18.07c3.04,2.46,6.59,3.91,10.4,3.96c3.98-0.06,7.69-1.63,10.82-4.31
					c4.62-3.94,7.99-10.29,9.11-17.72"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="71.942"
                y1="67.463"
                x2="76.632"
                y2="67.463"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="91.442"
                y1="67.463"
                x2="86.742"
                y2="67.463"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M76.962,83.923c1.64,1.24,3.45,1.95,5.3,1.95c1.85,0,3.65-0.71,5.29-1.95"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M63.432,65.863c0.09,0.1,0.19,0.18,0.27,0.29c-0.01-2.28,0.2-5.25,1.13-8.57c0.52-1.9,1.18-3.54,1.82-4.92
					c4.53,0.95,9.84,2.39,15.61,4.62l0.67-6.32l18.15,14.9c0-0.02,0-0.02,0-0.02c0.68-0.72,1.6-1.84,2.4-3.35
					c0.2-0.38,0.39-0.78,0.55-1.18c2.21-5.41,0.99-11.96,0.71-13c-5.42-20.57-39.88-19.28-44.97,0c-0.27,1.03-1.48,7.45,0.65,12.83
					c0.18,0.46,0.39,0.91,0.62,1.35c0.79,1.49,1.7,2.6,2.37,3.32c0,0.01,0.01,0.02,0.02,0.03
					C63.432,65.843,63.432,65.843,63.432,65.863z"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="96.072"
                y1="53.603"
                x2="96.072"
                y2="61.073"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M37.472,129.763c0.88-13.4,9.45-24.69,21.34-29.5c2.18-0.89,4.48-1.56,6.87-1.98"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M66.102,98.223c4.62,3.93,10.21,6.23,16.13,6.25"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="82.282"
                y1="106.803"
                x2="82.282"
                y2="131.313"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M98.872,98.283c2.68,0.48,5.26,1.26,7.69,2.33c11.47,4.99,19.66,16.07,20.51,29.15"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M98.452,98.223c-4.63,3.93-10.21,6.23-16.14,6.25c-0.03,0-0.05,0-0.08,0"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M71.622,89.953c0,0-0.23,0.92-0.68,2.15c-0.85,2.26-2.46,5.58-4.84,6.12c-0.08,0.02-0.16,0.04-0.25,0.05"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M93.132,89.953c0,0,0.21,1.09,0.67,2.47c0.77,2.32,2.25,5.46,4.65,5.8"
              />

              <circle
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                cx="138.272"
                cy="64.903"
                r="24.78"
              />

              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					133.932,53.283 133.932,76.223 148.642,64.043 				"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default MedicalVideoIcon
